import { FormField } from '../../../types/form-builder.types';
import { Input } from '@shondalai/ui-commons';

interface ColorFieldProps {
  field: FormField;
  value: string;
  onChange: (value: string) => void;
}

export function ColorField({ field, value, onChange }: ColorFieldProps) {
  const config = field.config;
  const disabled = (config as any).disabled;

  return (
    <div className="easyforms-color-field">
      <div className="flex items-center gap-3">
        <Input
          id={field.id}
          type="color"
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className="w-20 h-10 p-1 cursor-pointer"
        />
        <Input
          type="text"
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#000000"
          disabled={disabled}
          className="flex-1"
        />
      </div>
      {config.helpText && (
        <p className="text-xs text-muted-foreground mt-1">{config.helpText}</p>
      )}
    </div>
  );
}


